import React, { useEffect, useRef, useState } from "react";

// Background of the closest ancestor that has one, so the "Leer más" overlay
// blends with the row (rows change color, e.g. aditivos in yellow).
const getFondo = (element) => {
  let current = element;
  while (current && current !== document.body) {
    const color = window.getComputedStyle(current).backgroundColor;
    if (color && color !== "transparent" && !color.endsWith(", 0)")) {
      return color;
    }
    current = current.parentElement;
  }
  return "#fff";
};

const linkStyle = {
  cursor: "pointer",
  textTransform: "none",
  whiteSpace: "nowrap",
};

// Shows up to `lineas` lines; when the text is longer, an inline "Leer más"
// at the end of the last line expands it to the full text.
const TextoExpandible = ({ children, lineas = 2 }) => {
  const [expandido, setExpandido] = useState(false);
  const [desborda, setDesborda] = useState(false);
  const [fondo, setFondo] = useState("#fff");
  const ref = useRef(null);

  useEffect(() => {
    const element = ref.current;
    if (!element || expandido) return;
    const medir = () => {
      setDesborda(element.scrollHeight > element.clientHeight + 1);
      setFondo(getFondo(element));
    };
    medir();
    if (typeof ResizeObserver === "undefined") return;
    const observer = new ResizeObserver(medir);
    observer.observe(element);
    return () => observer.disconnect();
  }, [children, expandido]);

  const toggle = (e) => {
    e.stopPropagation();
    setExpandido(!expandido);
  };

  if (expandido) {
    return (
      <span>
        {children}{" "}
        <span className="text-primary" style={linkStyle} onClick={toggle}>
          Leer menos
        </span>
      </span>
    );
  }

  return (
    <span className="d-block position-relative">
      <span
        ref={ref}
        style={{
          display: "-webkit-box",
          WebkitLineClamp: lineas,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
        }}
      >
        {children}
      </span>
      {desborda && (
        <span
          className="text-primary position-absolute"
          onClick={toggle}
          style={{
            ...linkStyle,
            right: 0,
            bottom: 0,
            paddingLeft: "2.5em",
            background: `linear-gradient(to right, transparent, ${fondo} 2em)`,
          }}
        >
          … Leer más
        </span>
      )}
    </span>
  );
};

export default TextoExpandible;
